let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Bbuc")).then(() => parcelRequire('7i1h4'));